import React from "react";
import styled from "styled-components";
import { labelKeyMap } from "../../utils/general-config";

const CircleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin: 0 auto;
  width: 100%;
  max-width: 500px;

  .option-row {
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
  }

  .option-row.first-row {
    max-width: 380px;
    gap: 0.3rem;

    @media (max-width: 768px) {
      max-width: 320px;
      gap: 0.8rem;
    }

    @media (max-width: 480px) {
      max-width: 280px;
      gap: 0.5rem;
    }
  }

  .option-row.second-row {
    max-width: 380px;
    gap: 0.3rem;

    @media (max-width: 768px) {
      max-width: 320px;
      gap: 0.8rem;
    }

    @media (max-width: 480px) {
      max-width: 280px;
      gap: 0.5rem;
    }
  }

  label {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .option-button {
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;
    font-weight: 600;
    cursor: pointer;

    &.disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  /* Small buttons (first 3) */
  .small-option {
    width: 120px;
    height: 55px;
    border-radius: 30px;
    font-size: 18px;

    @media (max-width: 768px) {
      width: 100px;
      height: 55px;
      font-size: 16px;
      border-radius: 25px;
    }

    @media (max-width: 480px) {
      width: 80px;
      height: 45px;
      font-size: 14px;
      border-radius: 22px;
    }
  }

  /* Large buttons (last 2) */
  .large-option {
    width: 180px;
    height: 55px;
    border-radius: 30px;
    font-size: 18px;
    padding: 0 0.75rem;

    @media (max-width: 768px) {
      width: 150px;
      height: 55px;
      font-size: 16px;
      border-radius: 25px;
      padding: 0 0.5rem;
    }

    @media (max-width: 480px) {
      width: 135px;
      height: 50px;
      font-size: 13px;
      border-radius: 25px;
      padding: 0 0.6rem;
      white-space: normal;
      word-wrap: break-word;
      line-height: 1.2;
    }
  }

  .quiz-option-selected {
    background-color: #805aed !important;
    color: white !important;
    border: 2px solid #805aed !important;
  }

  .quiz-option-unselected {
    background-color: #f5f5f5;
    color: #805aed;
    border: 2px solid #ccc;
  }

  .quiz-option-unselected:hover {
    background-color: #e8d5ff !important;
  }
`;

function QuizOption({
  option = [],
  question,
  index,
  currentIndex,
  isQuizComplete,
  userAnswers,
  handleAnswerChange,
  isProcessing = false,
  currentLocale,
}) {
  const renderOptionButton = (opt, optionIndex, buttonType) => {
    const isSelected = userAnswers[question.id] === optionIndex + 1;
    const disabled = index > currentIndex || isQuizComplete;
    const labelKey = labelKeyMap[currentLocale];
    const label = opt[labelKey];

    return (
      <label key={opt.id} className="text-center">
        <input
          type="radio"
          name={`question-${question.id}`}
          className="hidden"
          onChange={(e) =>
            handleAnswerChange(e, question.id, index, opt.isCorrect)
          }
          checked={isSelected}
          value={optionIndex + 1}
          disabled={disabled || isProcessing}
        />
        <div
          className={`option-button ${buttonType} ${
            disabled || isProcessing ? "disabled" : ""
          } ${isSelected ? "quiz-option-selected" : "quiz-option-unselected"}`}
          style={{
            backgroundColor: isSelected ? "#805aed" : "#f5f5f5",
            color: isSelected ? "white" : "#805aed",
            border: ` ${
              isSelected ? "2px solid #805aed" : "1px solid #805aed"
            }`,
          }}
        >
          {label}
        </div>
      </label>
    );
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <CircleContainer className="mx-auto">
        {/* First row - first 3 options */}
        <div className="option-row first-row">
          {option
            .slice(0, 3)
            .map((opt, i) => renderOptionButton(opt, i, "small-option"))}
        </div>

        {/* Second row - remaining options */}
        {option.length > 3 && (
          <div className="option-row second-row">
            {option
              .slice(3)
              .map((opt, i) => renderOptionButton(opt, i + 3, "large-option"))}
          </div>
        )}
      </CircleContainer>
    </div>
  );
}

export default QuizOption;
